// src/components/ThemeToggle.jsx
import React, { useState, useEffect } from 'react';
import { useTheme } from '../context/ThemeContext';
import '../assets/styles/ThemeToggle.css';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const [isAnimating, setIsAnimating] = useState(false);
  
  const handleThemeToggle = () => {
    if (isAnimating) return;
    
    setIsAnimating(true);
    toggleTheme();
    
    // Reset animation state after transition completes
    setTimeout(() => {
      setIsAnimating(false);
    }, 700);
  };

  return (
    <button 
      className={`theme-toggle ${isAnimating ? 'animating' : ''}`}
      onClick={handleThemeToggle}
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
      title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
      disabled={isAnimating}
    >
      <div className="toggle-background">
        {/* Sky background */}
        <div className="sky-background"></div>
        
        {/* Stars (only visible in dark mode) */}
        <div className="stars">
          <div className="star" style={{ top: '20%', left: '15%' }}></div>
          <div className="star" style={{ top: '40%', left: '25%' }}></div>
          <div className="star" style={{ top: '30%', left: '45%' }}></div>
          <div className="star" style={{ top: '60%', left: '35%' }}></div>
          <div className="star" style={{ top: '70%', left: '20%' }}></div>
          <div className="star" style={{ top: '50%', left: '10%' }}></div>
          <div className="star" style={{ top: '25%', left: '30%' }}></div>
          <div className="star" style={{ top: '65%', left: '40%' }}></div>
        </div>
        
        {/* Clouds (only visible in light mode) */}
        <div className="clouds">
          <div className="cloud" style={{ top: '25%', left: '60%' }}></div>
          <div className="cloud" style={{ top: '55%', left: '75%' }}></div>
          <div className="cloud" style={{ top: '40%', left: '50%' }}></div>
        </div>
        
        {/* Sun/Moon toggle indicator */}
        <div className="celestial-body"></div>
      </div>
    </button>
  );
};

export default ThemeToggle;